/**
 * @generated SignedSource<<b7cc016ffbda7e425857726f7176dbd3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_sku">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_sku";
};
export type PdpRespSidebarBlurbs_sku$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_sku",
  "selections": [
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarBlurbShipping_sku"
        }
      ]
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "612f80ed9a6abb22240179cc5e299083";

export default node;
